import { useEffect, useRef } from 'react';
import { useSetEphemeralBanner } from '@/components/auth';
import { trackSignInPromptShown } from '@/analytics';

interface AnonSessionInput {
  isAuthenticated: boolean;
  signIn: () => void;
  anonHasStartedSession: boolean;
}

export const useAnonSession = (input: AnonSessionInput) => {
  const setEphemeralBanner = useSetEphemeralBanner();
  const promptTrackedRef = useRef(false);

  useEffect(() => {
    if (!input.isAuthenticated && input.anonHasStartedSession && !promptTrackedRef.current) {
      trackSignInPromptShown('ephemeral_banner');
      promptTrackedRef.current = true;
    }
    if (input.isAuthenticated || !input.anonHasStartedSession) {
      promptTrackedRef.current = false;
    }
    setEphemeralBanner(
      !input.isAuthenticated
        ? { visible: input.anonHasStartedSession, onLogin: input.signIn }
        : null,
    );
  }, [input.isAuthenticated, input.anonHasStartedSession, input.signIn, setEphemeralBanner]);
};
